// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"RunsTable_checkbox__2zLID","checkedCheckbox":"RunsTable_checkedCheckbox__1eklX","sortingBox":"RunsTable_sortingBox__2QMkA"};